
















































































































declare var window: any;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Navigator from './Navigator.vue';
import Resume from './Resume.vue';
import Address from './Address.vue';
import WorkExperience from './WorkExperience.vue';
import Skills from './Skills.vue';
import MyDocuments from '@/components/MyProfile/MyDocuments.vue';
import ProfessionalReference from './ProfessionalReference.vue';
import CertificationQuestioner from './CertificationQuestioner.vue';
import MissingMandatory from './MissingMandatory.vue';
import ProfilePicture from './ProfilePicture.vue';
import Header from './Header.vue';
import { vxm } from '@/store.vuex';
import ProgressBar from '@/components/Commons/ProgressBar.vue';
import EducationHistory from '@/components/Commons/EducationHistory.vue';
import UserPreference from '@/components/MyProfile/WorkPreference.vue';
import ContinueScreen from './ContinueScreen.vue';
import AdditionalDocuments from '@/components/MyProfile/AdditionalDocuments.vue';
import ErrorModal from '@/components/Commons/ErrorModal.vue';
import MissingMandatoryStep from '@/components/GuidedSignup/MissingMandatoryStepV2.vue';
import RoleSelection from '@/components/GuidedSignup/RoleSelection.vue';
import SourceType from '@/components/GuidedSignup/SourceType.vue';
import Language from '@/components/MyProfile/Language.vue';
import ProtectedInformation from '@/components/MyProfile/ProtectedInformation.vue';
import WereYouReferred from './WereYouReferred.vue';
import { MY_PROFILE_WIZARD_COMPONENT_MAPPER } from '@/models/configs/ProfileConstants';

const FINAL_STEP_NAME = 'FINAL';

@Component({
  components: {
    RoleSelection,
    EducationHistory,
    Resume,
    ProfessionalReference,
    CertificationQuestioner,
    MissingMandatory,
    Navigator,
    'user-address': Address,
    protected_information: ProtectedInformation,
    WorkExperience,
    Skills,
    MyDocuments,
    ProfilePicture,
    'guided-signup-header': Header,
    ProgressBar,
    UserPreference,
    ContinueScreen,
    AdditionalDocuments,
    ErrorModal,
    MissingMandatoryStep,
    SourceType,
    Language,
    WereYouReferred,
  },
})
export default class WrapperV2 extends Vue {
  @Prop() openSectionIndex;
  @Prop() openSection;
  private disableNext = true;
  private isFinished = false;
  private nextText = '';
  private sections: Array<string> = [];
  private selectedSection: number = 0;
  private showContinueScreen: boolean = false;
  private applicationSubmittedOnce: boolean = false;
  private roleSelected: boolean = false;
  private bus = new Vue();
  private missedMandatoryList: any[] = [];
  private showMissedMandatoryScreen: boolean = false;
  private saveAndExitScreenIndex: number = -1;
  @Watch('selectedSection')
  onChangeStep() {
    vxm.users.getProfileWizardStepInfo();
  }

  get canShowSkipButton() {
    return this.currentStep && this.currentStep.skipEnabled;
  }

  get canShowCloseButton() {
    if (this.currentSection === 'MY_DOCUMENTS') {
      const skillsStep =
        this.profileWizardSteps.find &&
        this.profileWizardSteps.find(
          (step) => step.stepName === 'SKILLS',
        );
      if (skillsStep) {
        return skillsStep.closeEnabled;
      } else {
        return true;
      }
    }
    return this.currentStep && this.currentStep.closeEnabled;
  }

  get IsConfigJSONEnabled() {
    return window.WorkLLama.isConfigJSONEnabled === 'true';
  }

  async mounted() {
    if (vxm.configs.getGlobalConfigValue('GSU_AFTER_JOB_APPLY')) {
      vxm.jobs.setGuidedSignUpOccured(true);
    }
    vxm.utility.setIsNewlyRegisterdUser(false);
    let steps = this.profileWizardSteps
      //.filter((step) => step.extraConfig.permissionConfig.user.view === 'true')
      .map((step) => step.sectionKey);
    
    this.saveAndExitScreenIndex = steps.indexOf('SAVE_AND_EXIT')-1;
    // steps = steps.filter(step => step !== 'SAVE_AND_EXIT')
    let sections = steps.length
      ? steps
      : [
          'RESUME',
          'ADDRESS',
          'WORK_EXPERIENCE',
          'SKILLS',
          //'profile-picture',
        ];

    this.nextText = this.$t('global-save-continue-text').toString();
    if (this.openSectionIndex) {
      this.selectedSection = Number(this.openSectionIndex);
    }

    // Check/remove Were You Referred if One time visibility.
    const wyrIndex = steps.findIndex((s) => s === 'WERE_YOU_REFERRED');
    if (wyrIndex === -1) {
      sections = sections.filter(
        (sectionName) => sectionName !== 'WERE_YOU_REFERRED',
      );
    }

    if (sections.includes('SOURCE_TYPE')) {
      try {
        const response = await vxm.users.getSourceTypeDetails();
        if (response && response.meta.success) {
          let responseData = response.data.customFields.candidateCustomMetaData;
          const sourceField = responseData[0];
          if (
            sourceField.defaultValue &&
            sourceField.defaultValue.toLowerCase() !== 'engage' &&
             sourceField.defaultValue.toLowerCase() !== 'workllama'
          ) {
            sections = sections.filter(
              (sectionName) => sectionName !== 'SOURCE_TYPE',
            );
          }
        }
      }
      catch(e) {

      }
      
    }
    if (this.openSection) {
      this.selectedSection = sections.indexOf(this.openSection);
    }
    this.sections = sections;
  }

  get enableRoleBasedGsuSteps() {
    return vxm.configs.getGlobalConfigValue('ENABLE_ROLE_BASED_GSU_STEPS');
  }

  updateRoleSelected(value) {
    this.roleSelected = value;
  }

  updateSections(payload) {
    this.sections = payload;
  }

  get showMyDocumentsSection() {
    return vxm.configs.getGlobalConfigValue('SHOW_MY_DOCUMENTS_SECTION_IN_GUIDED_SIGNUP')
  }

  updateMyDocumentSection() {
    // Show My Documents page only if suporting document are hidden from skill section
    if (!this.showMyDocumentsSection) return;

    // Get existing section index
    const myDocumentsIndex = this.sections.findIndex(
      (section) => section === 'MY_DOCUMENTS',
    );
    // Check for required attributes
    let requiredAttributes = vxm.users.myUserProfile.userAttributeSkills;
    if (requiredAttributes && requiredAttributes.length) {
      if (myDocumentsIndex === -1) {
        const skillsIndex = this.sections.findIndex(
          (section) => section === 'SKILLS',
        );
        // Add my document section
        skillsIndex !== -1 &&
          this.sections.splice(skillsIndex + 1, 0, 'MY_DOCUMENTS');
      }
    } else if (myDocumentsIndex !== -1) {
      // Remove my document section
      this.sections.splice(myDocumentsIndex, 1);
    }
  }

  async relaunchGuidedSignup() {
    await vxm.users.getProfileWizardStepInfo();
    const missing: any = vxm.users.RequiredStepsInfo.requiredStepsMissing;
    this.selectedSection = this.sections.findIndex((step) => {
      return missing.find((missedStep: any) => {
        return step === missedStep;
      });
    });
    this.applicationSubmittedOnce = true;
    this.showMissedMandatoryScreen = false;
  }

  openMandatoryStep(step) {
    const selectedSection = this.sections.findIndex(
      (section) => section === step,
    );
    if (selectedSection >= 0) {
      this.selectedSection = selectedSection;
    } else {
      const missing: any = vxm.users.RequiredStepsInfo.requiredStepsMissing;
      this.selectedSection = this.sections.findIndex((step) => {
        return missing.find((missedStep: any) => {
          return step === missedStep;
        });
      });
    }
  }

  get header() {
    if (this.isFinished) {
      const finalStep = this.getStep(FINAL_STEP_NAME);
      return finalStep && finalStep.sectionHeader
        ? finalStep.sectionHeader
        : this.$t(`guidedsignup.final.header`);
    }
    const stepComponentName = this.getStepComponentName(
      this.sections[this.selectedSection],
    );
    return this.currentStep && this.currentStep.sectionHeader
      ? this.currentStep.sectionHeader
      : this.$t(`guidedsignup.${stepComponentName}.header`);
  }

  get isRequiredStep() {
    let currentSection = this.sections[this.selectedSection];
    const step = this.getStep(currentSection);
    return step && step.stepRequired ? true : false;
  }

  get isLastStep(){
    console.log("isLastStep..........");
    let currentSection = this.sections[this.selectedSection];
    let lastSection = this.sections[this.sections.length-1];
   return currentSection === lastSection ? true :false;
  }

  get minimumEntries(){
    let currentSection = this.sections[this.selectedSection];
    return vxm.configs.getMinimumEntriesConfig(currentSection)
  }

  get subHeader() {
    if (this.isFinished) {
      const finalStep = this.getStep(FINAL_STEP_NAME);
      return finalStep && finalStep.sectionSubHeader
        ? finalStep.sectionSubHeader
        : this.$t(`guidedsignup.final.subheader`);
    }

    const stepComponentName = this.getStepComponentName(
      this.sections[this.selectedSection],
    );

    if (this.currentStep && this.currentStep.meta) {
      const stepMeta = JSON.parse(this.currentStep.meta);
      if (stepMeta.minimumEntries > 1) {
        return `Provide at least  ${stepMeta.minimumEntries} ${this.header}`;
      }
    }
    return this.currentStep && this.currentStep.sectionSubHeader
      ? this.currentStep.sectionSubHeader
      : this.$t(`guidedsignup.${stepComponentName}.subheader`);
  }

  getStep(stepName: string): any {
    const step = this.getWizardSection(stepName);
    const profileSection = this.getProfileSection(stepName);
    const stepComponentName = this.getStepComponentName(stepName);
    if (!(step && profileSection)) {
      console.log('Error: step or profile section not found', stepName);
      return {};
    }
    return {
      ...step,
      stepName: stepComponentName,
      sectionHeader: profileSection.h1 || step.displayName,
      sectionSubHeader: profileSection.h2,
      stepRequired: profileSection.required,
    };
  }

  get currentStep(): any {
    return this.getStep(this.sections[this.selectedSection]);
  }

  get currentStepSectionKey() {
    return this.sections[this.selectedSection];
  }

  get currentSection() {
    return this.getStepComponentName(this.sections[this.selectedSection]);
  }

  getStepComponentName(stepName: string): string {
    return (
      MY_PROFILE_WIZARD_COMPONENT_MAPPER[stepName] ||
      stepName.replace(/_/g, '-').toLowerCase()
    );
  }

  get profileWizardSteps(): any[] {
    return vxm.configs.ClientConfigs.profileWizardConfig.profileSections;
  }
  getWizardSection(sectionKey: string) {
    return vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
      (section) => section.sectionKey === sectionKey,
    );
  }
  getProfileSection(sectionKey: string) {
    return vxm.configs.ClientConfigs.userProfileSections.find(
      (section) => section.sectionKey === sectionKey,
    );
  }

  updateDisableNext(val) {
    this.updateMyDocumentSection();
    this.disableNext = val;
    console.log('updateDisableNext ', val)
  }
  async onSkip() {
    if (this.selectedSection >= this.sections.length - 1) {
      this.goToHomePage();
      return;
    }

    this.updateContinueScreen(
      this.saveAndExitScreenIndex === this.selectedSection + 1,
    );
    this.updateDisableNext(true);
    if (!this.applicationSubmittedOnce) {
      ++this.selectedSection;
      return;
    }
    await vxm.users.getProfileWizardStepInfo();
    if (
      vxm.users.RequiredStepsInfo.requiredStepsMissing.find(
        (step: string) =>
          step.toLowerCase().replace(/-|_/g, '') ===
          this.sections[this.selectedSection].replace(/-|_/g, ''),
      )
    ) {
      this.$modal.show(
        ErrorModal,
        {
          header: this.$t('Wrapper_MandatorySection'),
          onOk: () => {},
        },
        {
          height: 'auto',
          clickToClose: false,
        },
      );
    } else {
      ++this.selectedSection;
    }
  }

  goToNext() {
    if (this.selectedSection >= this.sections.length - 1) {
      this.isFinished = true;
      this.nextText = this.$t('sidemenu.findjobs').toString();
      this.selectedSection = this.sections.length - 1;
      this.sections[this.selectedSection] !== 'profile-picture' &&
        this.goToHomePage();

      return;
    }
    this.updateContinueScreen(
      this.saveAndExitScreenIndex === this.selectedSection,
    );
    ++this.selectedSection;
    this.updateDisableNext(true);
  }
  onNext() {
    if (this.isFinished) {
      return this.$router.push({ name: 'Findjobs' });
    }
    this.bus.$emit('on-next-step', {
      section: this.sections[this.selectedSection],
    });
  }
  onCancel() {
    if (this.selectedSection <= 0) {
      return (this.selectedSection = 0);
    }
    --this.selectedSection;
    this.updateContinueScreen(
      this.saveAndExitScreenIndex === this.selectedSection,
    );
    return;
  }
  get profileStrength() {
    return vxm.users.myUserProfile.userProfileStrength;
  }
  get role() {
    return vxm.users.myUserProfile.role;
  }

  setMissedMandatoryList(missedMandatorySteps: any[]) {
    this.showMissedMandatoryScreen = true;
    this.missedMandatoryList = missedMandatorySteps;
  }

  updateNextText(text) {
    this.nextText = text;
  }
  updateContinueScreen(val, update?: boolean) {
    this.showContinueScreen = val;
    if(update){
      ++this.selectedSection;
    }
  }
  goToHomePage() {
    let homeMenu: any = 'false';
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      homeMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (menu) => menu.sectionKey === 'HOME' && menu.signInVisibility,
      );
    } else {
      homeMenu = vxm.utility.leftMenuOptions.find(
        (menu) => menu.alias === 'home' && menu.signInVisibility,
      );
    }
    if (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_AFTER_SIGN_IN') === 'FIND_JOBS'
    ) {
      this.$router.push({ path: 'findjobs' });
    } else {
      this.$router.push({ path: homeMenu ? 'home' : 'findjobs' });
    }
  }
}
